import { Dialog, styled } from "@material-ui/core";

/**
 * The overlay and container for a dialog.
 *
 * See the API for overriding the styles applied to it's components:
 * https://v4.mui.com/api/dialog/#css
 */
export const DialogContainer = styled(Dialog)(({ theme }) => ({
  "&.MuiDialog-root": {
    backdropFilter: "blur(2px)",
  },
  "& .MuiDialog-paper": {
    display: "block",
    padding: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(4),
    },
  },
}));
